import { useCallback } from 'react';
import { backendErrorMessage, parseErrorBody, useApiCall } from './apiHelpers';
import { CheckOperationError, ValidationIssue, toValidationIssues } from '../../utils/checkOperationErrors';

export interface ValidateCommunicationPayload {
  communicationInputId: number;
  acceptBATVisualization: 0 | 1;
  acceptCGV: 0 | 1;
  needImmediateExtract: 0 | 1;
}

export interface ValidateCommunicationResult {
  success: boolean;
  message: string;
  actionStatusId: number;
}

export type ValidateCommunicationOutcome =
  | { ok: true; result: ValidateCommunicationResult }
  | { ok: false; message: string; issues: ValidationIssue[] };

const checkOperationErrors = (err: unknown): CheckOperationError[] => {
  const errors = (parseErrorBody(err)?.checkOperation as { errors?: unknown } | undefined)?.errors;
  return Array.isArray(errors) ? (errors as CheckOperationError[]) : [];
};

const useValidateCommunication = () => {
  const { authFetch, isReady, run, isLoading, error } = useApiCall(backendErrorMessage);

  const validateCommunication = useCallback(
    async (payload: ValidateCommunicationPayload): Promise<ValidateCommunicationOutcome> => {
      if (!isReady) return { ok: false, message: 'Session non prête, veuillez réessayer.', issues: [] };
      const outcome = await run<ValidateCommunicationResult>(
        () => authFetch('/communication/validate', { method: 'POST', body: JSON.stringify(payload) }),
        "Erreur lors de la vérification de l'opération",
      );
      if (outcome.ok) return { ok: true, result: outcome.data };
      return { ok: false, message: outcome.message, issues: toValidationIssues(checkOperationErrors(outcome.cause)) };
    },
    [authFetch, isReady, run],
  );

  return { validateCommunication, isLoading, error };
};

export default useValidateCommunication;
